import React, { useEffect } from 'react';
import { BoxStyled, TypographyStyledHeader } from './style';
import { NavigationButtonsStyled } from '../../../shared/components/navigationButtonsStyled';
import { useAppSelector } from '../../../store/hooks';
import { metaDataSelector } from '../../../store/globalSelectors';
import { estimatinRequirementsTileData } from '../../../shared/shared.constants';
import { TileSleekGridGroup } from '../../../shared/components/tileSleekGridGroup';

import { useDispatch } from 'react-redux';
import { setRouteArr, setRouteObj } from '../../../store/slices/metaDataSlice';

export const ESLandingScreen = () => {
  const {
    optedOptions,
    patientInformation: { metric }
  } = useAppSelector(metaDataSelector);
  const { routeArr, routeObj } = optedOptions;
  const dispatch = useDispatch();

  useEffect(() => {
    if (routeArr.length) {
      dispatch(
        setRouteArr(
          routeArr.filter((item) => item !== '/estimating-requirements')
        )
      );
      dispatch(setRouteObj({ ...routeObj, estimating_requirements: false }));
    }
  }, []);

  const filteredestimatinRequirementsTileData =
    estimatinRequirementsTileData.map((item) => {
      if (
        item.tileText.toLowerCase().trim() === 'harris benedict' ||
        item.tileText.toLowerCase().trim() === 'mifflin-st. jeor'
      ) {
        if (!metric.height) {
          return { ...item, disabled: true };
        }
        return item;
      }
      return item;
    });

  return (
    <>
      <BoxStyled>
        <TypographyStyledHeader variant="h1" className="width-75">
          {`ESTIMATING REQUIREMENTS`}
        </TypographyStyledHeader>
        <TileSleekGridGroup tileData={filteredestimatinRequirementsTileData} />
      </BoxStyled>
      <NavigationButtonsStyled />
    </>
  );
};
